import useTranslation from 'next-translate/useTranslation';
import { PictureInPictureEnterIcon, PictureInPictureLeaveIcon } from '../../../cosmos/icons';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';
import { PICTURE_IN_PICTURE_ENTER_ICON_DIMENSIONS, PICTURE_IN_PICTURE_LEAVE_ICON_DIMENSIONS } from './constants';

export type PictureInPictureControlProps = {
  onClick: () => void;
  isActive: boolean;
  size?: 'large' | 'small';
  className?: string;
};

const PictureInPictureControl = ({ onClick, className, isActive, size = 'large' }: PictureInPictureControlProps) => {
  const { t } = useTranslation('common');
  const tooltipText = isActive ? t('tooltips.picture_in_picture.inactive') : t('tooltips.picture_in_picture.active');
  const ariaLabel = isActive
    ? t('aria_labels.controls.picture_in_picture.inactive')
    : t('aria_labels.controls.picture_in_picture.active');

  return (
    <TooltipWrapper tooltipText={tooltipText} tooltipPosition='top'>
      <IconButton
        data-testid='picture-in-picture-control'
        onClick={onClick}
        className={className}
        aria-label={ariaLabel}
        icon={
          isActive ? (
            <PictureInPictureLeaveIcon
              {...PICTURE_IN_PICTURE_LEAVE_ICON_DIMENSIONS[size]}
              data-testid='picture_in_picture_leave'
            />
          ) : (
            <PictureInPictureEnterIcon
              {...PICTURE_IN_PICTURE_ENTER_ICON_DIMENSIONS[size]}
              data-testid='picture_in_picture_enter'
            />
          )
        }
      />
    </TooltipWrapper>
  );
};

export default PictureInPictureControl;
